
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "../SubmissionFormSchema";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { RefreshCw, Loader2 } from "lucide-react";

interface PhotoFormFieldProps {
  form: UseFormReturn<TerraceFormValues>;
  onRefreshPhotos?: () => void;
  isLoading?: boolean;
  showRefreshButton?: boolean;
}

const PhotoFormField: React.FC<PhotoFormFieldProps> = ({ 
  form, 
  onRefreshPhotos, 
  isLoading = false,
  showRefreshButton = false 
}) => {
  return (
    <FormField
      control={form.control}
      name="photo_url"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Photo URL</FormLabel>
          <FormControl>
            <div className="flex gap-2">
              <Input 
                {...field} 
                placeholder="https://example.com/photo.jpg"
                value={field.value || ''}
              />
              {showRefreshButton && onRefreshPhotos && (
                <Button
                  type="button"
                  variant="outline"
                  onClick={onRefreshPhotos}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                  ) : (
                    <RefreshCw className="h-4 w-4" />
                  )}
                </Button>
              )}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PhotoFormField;
